const {
  LOAD_DAILYTEXTS,
  LOAD_DAILYTEXTS_ERROR,
  LOAD_DAILYTEXTS_SUCCESS,
  SAVE_DAILYTEXTS,
  SAVE_DAILYTEXTS_ERROR,
  SAVE_DAILYTEXTS_SUCCESS
} = require("../actions/dailytexts");

const dailytextsState = (loading = false, data = {}, error = "") => ({
  loading,
  data,
  error
});

export default function(state = dailytextsState(), { type, payload }) {
  switch (type) {
    case LOAD_DAILYTEXTS:
      return dailytextsState(true);
    case LOAD_DAILYTEXTS_ERROR:
      return dailytextsState(false, state.data, payload);
    case LOAD_DAILYTEXTS_SUCCESS:
      return dailytextsState(false, payload);
    case SAVE_DAILYTEXTS:
      return dailytextsState(true, payload);
    case SAVE_DAILYTEXTS_ERROR:
      return dailytextsState(false, state.data, payload);
    case SAVE_DAILYTEXTS_SUCCESS:
      return dailytextsState(false, state.data);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/dailytexts.js